import { ColorEnum } from '@/constants/color'
import { ComponentType, FC } from 'react'
import { View } from 'react-native'
import { SvgProps } from 'react-native-svg'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface IconContainerProps {
    Icon: ComponentType<SvgProps>
    color: ColorEnum
    size: number
}

const IconContainer: FC<IconContainerProps> = ({ Icon, color, size }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <View style={[styles.container, styles.extraContainer(color, size)]}>
            <Icon />
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    extraContainer: (color: ColorEnum, size: number) => ({
        backgroundColor: color,
        borderRadius: size / 2,
        height: size,
        width: size,
    }),
})

export default IconContainer
